module.exports = __webpack_public_path__ + "img/bannar2.c5b1d85c.png";